module.exports = __webpack_public_path__ + "static/media/behance.501ac685.svg";